import { Module, MutationTree, GetterTree, ActionTree } from "vuex"
import { RootState } from ".."

export interface SetupGridOption {
    title: string
    route: string
    disabled?: boolean
    hasWarning?: boolean
    img?: string
    icon?: string
}

export interface SetupGridState {
    topOptions: SetupGridOption[]
    bottomOptions: SetupGridOption[]
}

const state: SetupGridState = {
    topOptions: [
        {
            title: "setup.add_new_controller",
            route: "/setup/oem-device",
            img: "@/assets/images/units/oem-device/controller_128.webp", //this might be obsolete - img is set in SetupPage based on route property.
        },
        {
            title: "setup.add_new_p1",
            route: "/setup/p1-wifi",
            img: "@/assets/images/units/p1/p1_128.webp", //this might be obsolete - img is set in SetupPage based on route property.
        },
    ],
    bottomOptions: [
        {
            title: "setup.add_devices",
            route: "/setup/devices",
            disabled: true,
            icon: "icon icon-controllers",
        },
        {
            title: "setup.connect_external_services",
            route: "/external/integrations",
            icon: "fa fa-solid fa-microchip",
        },
        {
            title: "setup.define_pricing_plans",
            route: "/setup/pricing",
            icon: "icon icon-price-list",
        },
    ],
}

const mutations: MutationTree<SetupGridState> = {
    setTopOptions(state, options: SetupGridOption[]) {
        state.topOptions = options
    },
    setBottomOptions(state, options: SetupGridOption[]) {
        state.bottomOptions = options
    },
    resetState(state) {
        state.bottomOptions = state.bottomOptions.map((option) => ({
            ...option,
            hasWarning: false,
        }))
    },
}

const getters: GetterTree<SetupGridState, RootState> = {
    topOptions: (state) => state.topOptions,
    bottomOptions: (state, _getters, rootState, rootGetters) => {
        const user = rootGetters["auth/user"]
        const options = [...state.bottomOptions]
        const hasLocations = user?.locations?.length > 0

        if (hasLocations) {
            const missingPriceList = user.locations.some(
                (location: any) => location.activePriceList === null,
            )

            return options.map((option, index) =>
                index === 2 ? { ...option, hasWarning: missingPriceList } : option,
            )
        }

        return options.map((option, index) =>
            index === 2 ? { ...option, disabled: true } : option,
        )
    },
}

const actions: ActionTree<SetupGridState, RootState> = {}

const setupGridModule: Module<SetupGridState, RootState> = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
}

export default setupGridModule
